import PolicyDoc from '@/components/PolicyDoc';
import { REFUND_POLICY } from '@/shared/policy';

export const route = { path: '/refund-policy', layout: 'public', access: 'public' };

export default function RefundPolicy() {
  return <PolicyDoc doc={REFUND_POLICY} />;
}
